import { appendPath, getValue, parentPath } from '@truqc/content-path';
import { createSelector } from 'reselect';
import newPathSelector from './newPathSelector';
import { getContent } from './simpleSelectors';
const getConformance = (state, _ref) => {
  let conformance = _ref.format.conformance;
  return conformance;
};
const getErrorText = (state, _ref2) => {
  let errorText = _ref2.format.errorText;
  return errorText;
};
export default createSelector([getContent, getConformance, newPathSelector, getErrorText], (content, conformance, path, errorText) => {
  if (errorText) {
    return errorText;
  }
  if (!conformance) {
    return null;
  }
  const contentPath = conformance.contentPath,
    legacyErrorText = conformance.errorText;
  if (!contentPath || !legacyErrorText) {
    return null;
  }
  const conforms = getValue(appendPath(parentPath(path), contentPath), content);
  if (conforms === undefined) {
    return null;
  }
  return conforms ? null : legacyErrorText;
});